import { z } from "zod/mini"

export const BooleanLegacySchema = z.boolean()

export type BooleanLegacy = z.infer<typeof BooleanLegacySchema>
